import { ActionCard } from 'ui';

import { consumer } from '@tock/coretypes';
import { onBusinessWalkinWaitlistSelector } from 'selectors/walkinWaitlistSelectors';
import { useFeatureFlag } from '@tock/shared/utils/featureFlagContext';
import { useSelector } from 'react-redux';

import { ACTION_BUSINESS_CLICK_WALKIN_WAITLIST } from 'utils/analytics/eventTypeConstantsAmplitude';
import { FunctionComponent } from 'react';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { IconTaskClock } from 'ui/icons';
import { IconTimer } from '@tock/icons';
import { useConsumerConversionAnalytics } from 'hooks/analytics/useConsumerConversionAnalytics';

interface WalkinWaitlistActionCardProps {
  business: consumer.BusinessConfig | consumer.IBusinessConfig;
  className?: string;
}

const WalkinWaitlistActionCard: FunctionComponent<WalkinWaitlistActionCardProps> = ({
  business,
  className,
}) => {
  const waitlistDetail = useSelector(onBusinessWalkinWaitlistSelector);
  const patronOnWaitlist = useFeatureFlag('ONLINE_WALKIN_WAITLIST') && waitlistDetail;
  const href = `/${business.domainName}/walkin-waitlist`;
  const enabled = useFeatureFlag('ONLINE_WALKIN_WAITLIST') && business.onlineWalkinWaitlistEnabled;
  const sendConversionAnalytics = useConsumerConversionAnalytics();

  const headlineText = patronOnWaitlist ? "You're on the walk-in waitlist" : 'Coming in soon?';
  const descriptionText = patronOnWaitlist
    ? "Please ensure you're in the area and ready to be seated when notified."
    : 'Get a head start on the line at the door by joining the waitlist.';
  const actionText = patronOnWaitlist ? 'View the walk-in waitlist' : 'Join walk-in waitlist';

  return enabled ? (
    <ActionCard
      className={className}
      headline={headlineText}
      description={descriptionText}
      actionText={actionText}
      href={href}
      icon={<IconMigrationUtil legacyIcon={<IconTaskClock />} newIcon={<IconTimer />} />}
      CardActionAreaProps={{
        'aria-haspopup': 'true',
        onClick: () => {
          sendConversionAnalytics(ACTION_BUSINESS_CLICK_WALKIN_WAITLIST);
        },
      }}
    />
  ) : null;
};

export default WalkinWaitlistActionCard;
